import type { ReactElement } from 'react';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import '../toastify.css';

/**
 * Where `notify` messages are rendered. Mounted once, high in the tree.
 *
 * It exists so that the delivery mechanism is behind the same boundary as the
 * `notify` call itself: the app root asks for a place to show messages, not
 * for a toast container. Issue #1141 replaces what is inside here.
 */
export const MessageHost = (): ReactElement => (
  <div id="toast-root">
    <ToastContainer position="top-right" autoClose={3000} />
  </div>
);
